import { Outlet } from "react-router-dom";
import "../styles/layouts-styles/MainDashboardLayout.css"
import MainDashboardHeader from "../components/headers/MainDashboardHeader";
import LargeScreenDashboardSidebar from "../components/sidebar/LargeScreenDashboardSidebar";
import { useContext } from "react";
import { SidebarContext } from "../contexts/SidebarContext";
import HighYieldTextbookSidebar from "../components/sidebar/HighYieldTextbookSidebar";
import ExtendedTextbookSidebar from "../components/sidebar/ExtendedTextbookSidebar";
import UserProfileSidebar from "../components/sidebar/UserProfileSidebar";
import SmallScreenDashboardSidebar from "../components/sidebar/SmallScreenDashboardSidebar";

function MainDashboardLayout () {
    const { showLargeScreenSidebar, showSmallScreenSidebar } = useContext(SidebarContext);
    return(
        
        <div className="main-dashboard-layout-container">
            <LargeScreenDashboardSidebar />
            <SmallScreenDashboardSidebar />
            <HighYieldTextbookSidebar />
            <ExtendedTextbookSidebar />
            <UserProfileSidebar />
            <div className={
                `main-dashboard-header-and-main-content-container ${showLargeScreenSidebar ? 'sidebar-open' : 'sidebar-closed'}`
                }
            >
                <MainDashboardHeader />
                <div className="main-dashboard-main-content-container">
                    <Outlet />
                </div>
            </div>

            {/* Overlay to prevent interaction with main content when small screen sidebar is open */}
            {showSmallScreenSidebar && <div className="small-screen-sidebar-overlay"></div>}
        </div>
        
    )
    
}

export default MainDashboardLayout;